import { render, staticRenderFns } from "./summary-prf-soft-competency.vue?vue&type=template&id=303fac92"
import script from "./summary-prf-soft-competency.vue?vue&type=script&lang=js"
export * from "./summary-prf-soft-competency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports